import React from 'react'
import { TreeSelect, } from 'antd'


export class DatasourceSelector extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            value : props.value

        }
    }

    onSelect = (value) => {
        this.setState ({
            value : value
        })
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    
    }

    componentWillReceiveProps(nextProps) {
        // Should be a controlled component.
        if ('value' in nextProps) {
            const value = nextProps.value
            this.setState({ value: value });
        }
    }


    render() {

        return (
            <div>
                {this.props.label ? (<p>{this.props.label}</p>) : (<div />)}
                <TreeSelect
                    showSearch
                    style={{ width: 300 }}
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    // placeholder="Please select a datasource"
                    allowClear
                    treeDefaultExpandAll
                    value={this.state.value}
                    onSelect={this.onSelect}
                    treeData={this.props.treeData}
                >
                </TreeSelect>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/SolutionEditor/Predictions/DatasourceSelector.jsx